import React, { useState } from 'react';
import StageShell from './common/StageShell';
import { getProject, setStage, getSelectedArchitecture } from '../../services/sdlcProject.service';
import { synthesizeCicd } from './sdlcSynthesizers';

function CICDStage() {
  const [project, setProject] = useState(getProject());
  const arch = getSelectedArchitecture();
  const cicd = project?.cicd;
  const [activeFile, setActiveFile] = useState(0);

  const handleGenerate = () => {
    const result = synthesizeCicd({
      architecture: arch,
      requirementsReport: project?.requirements?.snapshot,
      tests: project?.tests,
    });
    const next = setStage('cicd', result);
    setProject(next);
    setActiveFile(0);
  };

  const inputs = [
    { label: 'Design', value: arch?.name || '' },
    { label: 'Code', value: project?.code?.snapshot ? `${(project.code.snapshot.files || []).length} files` : '' },
    { label: 'Tests', value: project?.tests?.framework || '' },
  ];

  const files = cicd?.files || [];

  return (
    <StageShell
      stageId="cicd"
      description="Generate the build, validation, test, package, and manual deployment pipeline files."
      inputs={inputs}
      canContinue={files.length > 0}
      actions={<button className="stage-btn primary" onClick={handleGenerate} disabled={!arch || !project?.tests?.files?.length}>
        {cicd ? 'Regenerate CI/CD' : 'Generate CI/CD'}
      </button>}
    >
      {!arch && (
        <div className="stage-empty">
          <div className="icon">🏛️</div>
          No design is selected. Pick a design first.
        </div>
      )}

      {arch && !project?.tests?.files?.length && (
        <div className="stage-empty">
          <div className="icon">🧪</div>
          Generate tests before creating the CI/CD pipeline.
        </div>
      )}

      {files.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: 12, marginTop: 12 }}>
          <div className="stage-file-list" style={{ marginTop: 0 }}>
            {files.map((file, index) => (
              <button
                key={file.path}
                type="button"
                className="stage-file-item"
                style={{
                  textAlign: 'left',
                  cursor: 'pointer',
                  background: activeFile === index ? '#eff6ff' : 'transparent',
                }}
                onClick={() => setActiveFile(index)}
              >
                <span>{file.path}</span>
              </button>
            ))}
          </div>
          <pre className="stage-pre">{files[activeFile]?.content}</pre>
        </div>
      )}
    </StageShell>
  );
}

export default CICDStage;